export default "__VITE_ASSET__CqlWQa09__"